/* ==========================================================================
   Aimer Atacado — Página /pages/dicas
   Filtro por tag (client-side, com estado na URL), "Ver mais" via Section
   Rendering API, contagem do índice do hero e lightbox de vídeo com facade.

   Sem dependências. Carregado por várias sections: o guard abaixo garante que
   o arquivo só se instala uma vez, mesmo com <script> duplicado.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__aimerDicas) return;
  window.__aimerDicas = true;

  var SEM_MOVIMENTO = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------- utils */

  function listaTags(el) {
    var bruto = (el.getAttribute('data-tags') || '').toLowerCase();
    return bruto
      .split('|')
      .map(function (t) {
        return t.trim();
      })
      .filter(Boolean);
  }

  function gravaNaUrl(param, valor) {
    if (!window.history || !window.history.replaceState) return;
    var url = new URL(window.location.href);
    if (valor) {
      url.searchParams.set(param, valor);
    } else {
      url.searchParams.delete(param);
    }
    window.history.replaceState({}, '', url.toString());
  }

  /* -------------------------------------------------------------- filtros */

  function aplicaFiltro(grupo, valor) {
    var itens = grupo.querySelectorAll('[data-tags]');
    var visiveis = 0;

    itens.forEach(function (item) {
      var mostra = !valor || listaTags(item).indexOf(valor) !== -1;
      // A matéria de capa já está no hero: na grade ela só entra com filtro ativo.
      if (!valor && item.hasAttribute('data-dicas-so-filtro')) mostra = false;
      item.hidden = !mostra;
      if (mostra) visiveis++;
    });

    // Sem filtro, a capa escondida não conta: a grade nunca fica "vazia" por causa dela.
    if (!valor && !visiveis && itens.length) visiveis = 1;

    grupo.querySelectorAll('[data-dicas-chip]').forEach(function (chip) {
      var v = (chip.getAttribute('data-valor') || '').toLowerCase();
      chip.setAttribute('aria-pressed', String(v === (valor || '')));
    });

    var vazio = grupo.querySelector('[data-dicas-vazio]');
    // enquanto as páginas restantes chegam, não anuncia "nenhuma matéria"
    if (vazio) vazio.hidden = visiveis !== 0 || grupo.dataset.carregando === '1';

    var lista = grupo.querySelector('[data-dicas-grid]');
    if (lista) lista.hidden = visiveis === 0;

    var rodape = grupo.querySelector('[data-dicas-rodape]');
    if (rodape) rodape.hidden = !!valor;

    grupo.dataset.filtroAtual = valor || '';
  }

  function iniciaFiltros(grupo) {
    if (grupo.dataset.dicasFiltroPronto) return;
    grupo.dataset.dicasFiltroPronto = '1';

    var param = grupo.getAttribute('data-param') || 'tag';

    grupo.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-dicas-chip]');
      if (chip && grupo.contains(chip)) {
        var valor = (chip.getAttribute('data-valor') || '').toLowerCase();
        if (valor === grupo.dataset.filtroAtual) valor = '';
        aplicaFiltro(grupo, valor);
        gravaNaUrl(param, valor);
        if (valor) {
          carregaTudo(grupo).then(function () {
            aplicaFiltro(grupo, grupo.dataset.filtroAtual || '');
          });
        }
        return;
      }

      var limpar = e.target.closest('[data-dicas-limpar]');
      if (limpar && grupo.contains(limpar)) {
        e.preventDefault();
        aplicaFiltro(grupo, '');
        gravaNaUrl(param, '');
      }
    });

    var inicial = new URL(window.location.href).searchParams.get(param) || '';
    inicial = inicial.toLowerCase();

    var existe = Array.prototype.some.call(
      grupo.querySelectorAll('[data-dicas-chip]'),
      function (chip) {
        return (chip.getAttribute('data-valor') || '').toLowerCase() === inicial;
      }
    );

    aplicaFiltro(grupo, existe ? inicial : '');
    if (existe && inicial) {
      carregaTudo(grupo).then(function () {
        aplicaFiltro(grupo, grupo.dataset.filtroAtual || '');
      });
    }
  }

  /* ------------------------------------------------------------- ver mais */

  // Busca a próxima página pela Section Rendering API e injeta os cards no grid.
  function carregaPagina(botao) {
    var grupo = botao.closest('[data-dicas-filtro-grupo]');
    var grid = grupo && grupo.querySelector('[data-dicas-grid]');
    if (!grid) return Promise.reject(new Error('Grid não encontrado'));

    var proxima = parseInt(botao.getAttribute('data-proxima'), 10);
    var total = parseInt(botao.getAttribute('data-total'), 10);

    var url = new URL(window.location.href);
    url.searchParams.set('section_id', botao.getAttribute('data-section-id'));
    url.searchParams.set('page', String(proxima));

    return fetch(url.toString())
      .then(function (r) {
        if (!r.ok) throw new Error('Falha ao buscar a página ' + proxima);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var novoGrid = doc.querySelector('[data-dicas-grid]');
        if (!novoGrid) throw new Error('Grid não encontrado na resposta');

        Array.prototype.forEach.call(novoGrid.children, function (filho) {
          grid.appendChild(filho.cloneNode(true));
        });

        if (proxima >= total) {
          botao.remove();
          return false;
        }
        botao.setAttribute('data-proxima', String(proxima + 1));
        return true;
      });
  }

  // O filtro é client-side: antes de filtrar, traz as páginas que faltam para a
  // tag não cair em "nenhuma matéria" só porque o artigo está na página 2.
  function carregaTudo(grupo) {
    var botao = grupo.querySelector('[data-dicas-vermais]');
    if (!botao || botao.getAttribute('aria-busy') === 'true') return Promise.resolve();

    botao.setAttribute('aria-busy', 'true');
    grupo.dataset.carregando = '1';
    function passo() {
      return carregaPagina(botao).then(function (temMais) {
        return temMais ? passo() : null;
      });
    }
    return passo()
      .catch(function () {
        if (document.body.contains(botao)) botao.removeAttribute('aria-busy');
      })
      .then(function () {
        grupo.dataset.carregando = '';
      });
  }

  function iniciaVerMais(botao) {
    if (botao.dataset.dicasPronto) return;
    botao.dataset.dicasPronto = '1';

    botao.addEventListener('click', function () {
      var grupo = botao.closest('[data-dicas-filtro-grupo]');
      var rotuloOriginal = botao.textContent;

      botao.setAttribute('aria-busy', 'true');
      botao.textContent = 'Carregando…';

      carregaPagina(botao)
        .then(function () {
          if (document.body.contains(botao)) {
            botao.textContent = rotuloOriginal;
            botao.removeAttribute('aria-busy');
          }
          aplicaFiltro(grupo, grupo.dataset.filtroAtual || '');
        })
        .catch(function () {
          botao.textContent = rotuloOriginal;
          botao.removeAttribute('aria-busy');
          var alvo = botao.getAttribute('data-url-blog');
          if (alvo) window.location.href = alvo;
        });
    });
  }

  /* ------------------------------------------------------------- lightbox */

  var lightbox = null;
  var origemFoco = null;

  function montaLightbox() {
    if (lightbox) return lightbox;

    lightbox = document.createElement('div');
    lightbox.className = 'dicas-lightbox';
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-label', 'Player de vídeo');
    lightbox.hidden = true;
    lightbox.innerHTML =
      '<div class="dicas-lightbox__caixa">' +
      '<button type="button" class="dicas-lightbox__fechar" data-dicas-fechar aria-label="Fechar vídeo">' +
      '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" aria-hidden="true" focusable="false">' +
      '<path d="M6.2 6.2l11.6 11.6"/><path d="M17.8 6.2L6.2 17.8"/></svg>' +
      '</button>' +
      '</div>';

    document.body.appendChild(lightbox);

    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox || e.target.closest('[data-dicas-fechar]')) fechaLightbox();
    });

    lightbox.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        fechaLightbox();
        return;
      }
      if (e.key !== 'Tab') return;
      // Focus trap: o único alvo focável estável é o botão de fechar.
      var focaveis = lightbox.querySelectorAll('button, iframe, [href]');
      if (!focaveis.length) return;
      var primeiro = focaveis[0];
      var ultimo = focaveis[focaveis.length - 1];
      if (e.shiftKey && document.activeElement === primeiro) {
        e.preventDefault();
        ultimo.focus();
      } else if (!e.shiftKey && document.activeElement === ultimo) {
        e.preventDefault();
        primeiro.focus();
      }
    });

    return lightbox;
  }

  function abreLightbox(idVideo, formato, origem) {
    var lb = montaLightbox();
    var caixa = lb.querySelector('.dicas-lightbox__caixa');

    origemFoco = origem || null;
    lb.classList.toggle('dicas-lightbox--short', formato === 'short');

    var iframe = document.createElement('iframe');
    iframe.src =
      'https://www.youtube-nocookie.com/embed/' +
      encodeURIComponent(idVideo) +
      '?autoplay=1&rel=0&modestbranding=1&playsinline=1&hl=pt-BR';
    iframe.title = 'Vídeo de dicas Aimer';
    iframe.allow =
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.setAttribute('allowfullscreen', '');
    caixa.appendChild(iframe);

    var largura = window.innerWidth - document.documentElement.clientWidth;
    if (largura > 0) document.body.style.paddingRight = largura + 'px';
    document.body.classList.add('dicas-travado');

    lb.hidden = false;
    lb.querySelector('[data-dicas-fechar]').focus({ preventScroll: true });
  }

  function fechaLightbox() {
    if (!lightbox || lightbox.hidden) return;

    var iframe = lightbox.querySelector('iframe');
    if (iframe) iframe.remove(); // remover do DOM é o que corta o áudio

    lightbox.hidden = true;
    document.body.classList.remove('dicas-travado');
    document.body.style.paddingRight = '';

    if (origemFoco && document.body.contains(origemFoco)) {
      origemFoco.focus({ preventScroll: SEM_MOVIMENTO });
    }
    origemFoco = null;
  }

  document.addEventListener('click', function (e) {
    var botao = e.target.closest('[data-dicas-video]');
    if (!botao) return;
    e.preventDefault();
    abreLightbox(
      botao.getAttribute('data-dicas-video'),
      botao.getAttribute('data-formato'),
      botao
    );
  });

  /* --------------------------------------------------- contagem do índice */

  // O hero não enxerga os blocos das outras sections; a contagem vem do DOM.
  function preencheIndice() {
    document.querySelectorAll('[data-dicas-conta-alvo]').forEach(function (alvo) {
      var fonte = document.querySelector(
        '[data-dicas-conta="' + alvo.getAttribute('data-dicas-conta-alvo') + '"]'
      );
      if (!fonte) return;
      var total = fonte.querySelectorAll('[data-dicas-item]').length;
      if (total) alvo.textContent = total + ' ' + (alvo.getAttribute('data-sufixo') || '');
    });
  }

  /* ----------------------------------------------------------------- boot */

  function inicia(raiz) {
    var escopo = raiz || document;
    preencheIndice();
    escopo.querySelectorAll('[data-dicas-filtro-grupo]').forEach(iniciaFiltros);
    escopo.querySelectorAll('[data-dicas-vermais]').forEach(iniciaVerMais);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      inicia();
    });
  } else {
    inicia();
  }

  // Personalizador do Shopify: sections re-renderizadas precisam reiniciar.
  document.addEventListener('shopify:section:load', function (e) {
    inicia(e.target);
  });

  document.addEventListener('shopify:section:unload', function () {
    fechaLightbox();
  });
})();
